var Profile = function() {
    const feedbackMsg = 'Η αλλαγή αποθηκεύτηκε!';

    $('#pm_email_notif').on('change', function() {
        const submitVal = Number($(this).is(':checked'));
        Ajax.profileSave({pm_email_notif: submitVal}, function(data) {
            Generic.showFeedback(data.success == 'ok' ? feedbackMsg : data.error);
        });
    });

    $('#newsletter').on('change', function() {
        const submitVal = Number($(this).is(':checked'));
        Ajax.profileSave({newsletter: submitVal}, function(data) {
            Generic.showFeedback(data.success == 'ok' ? feedbackMsg : data.error);
        });
    });

    $('#send-verification-email').on('click', function() {
        let newEmail = $('#new-email').val();
        if (!newEmail) {
            return;
        }
        Ajax.sendVerificationEmail(newEmail, (res) => {
            if (!res.message) {
                return;
            }
            if (Generic.mobile) {
                Generic.showFeedback(res.message);
                return;
            }
            let alertIcon = 'fa-check';
            if (res.success == 'failed') {
                alertIcon = 'fa-exclamation-triangle';
            }
            $('#email-dropdown .alert > i').addClass(alertIcon);
            $('#email-dropdown .alert > p').html(res.message);
            $('#email-dropdown .alert').removeClass('invisible');
        });
    });

    let oldPassword;
    let selectedAvatarTeamUrl;

    $('#old_password').on('input', function() {
        const disableNextStep = $(this).val() ? false : true;
        $('#password-next-step').prop('disabled', disableNextStep);
    });

    $('#password-next-step').on('click', function() {
        oldPassword = $('#old_password').val();
        if (!oldPassword) {
            return false;
        }
        $('.ii__password_step1').addClass('invisible');
        $('.ii__password_step2').removeClass('invisible');
    });

    $('#password, #password2').on('input', function() {
        let pass1 = $('#password').val();
        let pass2 = $('#password2').val();

        const disableSubmit = pass1 && (pass1 === pass2) ? false : true;
        $('#password-submit').prop('disabled', disableSubmit);
    });

    $('#password-submit').on('click', function() {
        let pass1 = $('#password').val();
        let pass2 = $('#password2').val();

        if (pass1 !== pass2 || !pass1) {
            return false;
        }

        Ajax.profileSave({
            old_password: oldPassword,
            password: pass1,
            password2: pass2
        }, function(data) {
            let alertIcon = 'fa-check';
            let msg = 'Επιτυχής αλλαγή κωδικού';
            if (data.success == 'failed') {
                alertIcon = 'fa-exclamation-triangle';
                msg = data.error;
            }
            if (Generic.mobile) {
                Generic.showFeedback(msg);
            } else {
                $('#password-dropdown .alert > i').removeClass('fa-check');
                $('#password-dropdown .alert > i').removeClass('fa-exclamation-triangle');
                $('#password-dropdown .alert > i').addClass(alertIcon);
                $('#password-dropdown .alert > p').html(msg);
                $('#password-dropdown .alert').removeClass('invisible');
            }

            $('.ii__password_step1').removeClass('invisible');
            $('.ii__password_step2').addClass('invisible');

            $('#password').val('');
            $('#password2').val('');
        });
    });

    function reset_profile_confirmation(action) {
        $(`#profile-${action}-username`).val('');
        $(`#profile-${action}-submit`).prop('disabled', true);
    }

    function applyAvatarUpdate(resp, avatarSrc) {
        let selectors = '#current-avatar, #menu-login img';
        if (Generic.mobile) {
            selectors = '.ii_show_profile > img, #drop_profile .profile__box--img img';
        }
        $(selectors).prop('src', avatarSrc ?? selectedAvatarTeamUrl);
        Generic.showFeedback(resp.success == 'ok' ? feedbackMsg : resp.error);
    }

    $('.profile-avatar-radio input[name=avatar]:not(#av_team_id)').on('change', function() {
        if (!$(this).is(':checked')) {
            return;
        }
        let el = this;
        // store new team
        Ajax.profileSave({avatar_id: $(this).val()}, function(data) {
            let avSrc = $(el).parent().find(`label[for=${el.id}] > img`).attr('src');
            applyAvatarUpdate(data, avSrc);
        });
    });

    $('#av_team_id').on('change', function() {
        if (!$(this).is(':checked')) {
            return;
        }
        // store new team
        let avTeamId = $(this).val();
        if (!avTeamId) {
            return;
        }
        Ajax.profileSave({avatar_team_id: avTeamId}, function(resp) {
            applyAvatarUpdate(resp, selectedAvatarTeamUrl || $('#current_team_avatar').prop('src'));
        });
    });

    for (const action of ['reset', 'del']) {
        $(`#profile-${action}-username`).on('input', function() {
            const disableSubmit = $(this).val() ? false : true;
            $(`#profile-${action}-submit`).prop('disabled', disableSubmit);
        });
        // reset modal input to avoid initial browser
        // autocomplete from filling the field
        $(`#modal-${action}`).on('show.bs.modal', function() {
            reset_profile_confirmation(action);
        });
    }

    $('#profile-reset-submit').on('click', function() {
        const username = $('#profile-reset-username').val();
        Ajax.profileReset(username, function(resp) {
            $('#modal-reset').modal('hide');
            Generic.showFeedback(resp.success == 'ok' ? feedbackMsg : resp.error);
            $('#profile-reset-username').val('');
        });
    });

    $('#profile-del-submit').on('click', function() {
        const username = $('#profile-del-username').val();
        Ajax.profileDelete(username, function(resp) {
            $('#modal-del').modal('hide');
            let msg = feedbackMsg + '<br>Ανακατεύθυνση στην αρχική σελίδα..';
            Generic.showFeedback(resp.success == 'ok' ? msg : resp.error);
            $('#profile-del-username').val('');
            if (resp.success == 'failed') {
                return;
            }
            setTimeout(function() {
                window.location.href = '/';
            }, 2000);
        });
    });

    return {
        init: function() {
            if (Generic.mobile) {
                $('.settings-block, .link-grey').click(function() {
                    $('.page').addClass('block-wrap-on');
                    $('.overlay__back').removeClass('d-none');
                });

                $('.block-overlay__close').click(function() {
                    $('.page').removeClass('block-wrap-on');
                    $('.overlay__back').addClass('d-none');
                });

                $('.settings-block, .link-grey').click(function() {
                    var target = $(this).attr('href');
                    $(target).addClass('block-on');
                    for (const action of ['reset', 'del']) {
                        if (target == `#block-${action}`) {
                            reset_profile_confirmation(action);
                        }
                    }
                });

                $('.block-overlay__close').click(function() {
                    $('.block-overlay').removeClass('block-on');
                });
            }

            $('#avatar_team').on('click', function(e) {
                e.stopPropagation();
                $('.page').addClass('ii__logopicker_overlay');
            });

            $(document).on('click', '.ii__logopicker_overlay', function(e) {
                e.stopPropagation();
                $('#logopicker').html('').hide();
                $('.page').removeClass('ii__logopicker_overlay');

            });

            $('#avatar_team').on('input', function() {
                const input_elem = $(this),
                    val = $(this).val()
                ;

                if (val == '') {
                    return;
                }

                const logopicker = $('#logopicker');
                logopicker.html('').hide();

                Ajax.logopicker(val, (res) => {
                    if (!(res.success == 'ok' && res.results)) {
                        return;
                    }

                    if (!res.results.length) {
                        logopicker.html(
                            '<div><span>Δεν βρέθηκαν αποτελέσματα.</span></div>'
                        ).show();
                        return;
                    }

                    const currentVal = String(input_elem.val()).trim();

                    let html = '<span class="logopicker__subtitle">Ομάδες</span>';
                    for (const result of res.results) {
                        const term = String(result.term).trim();
                        if (term != currentVal) {
                            return;
                        }
                        html += `
                            <a href="javascript:void(0);" class="logopicker__team ii__logopicker_team_select"
                                data-tid="${result.team_id}" data-logo=${result.logo} data-tname=${result.team_name}>
                                ${result.team_name}
                            </a>
                        `;
                    }
                    logopicker.html(html).show();
                });

                $(document).on('click', '.ii__logopicker_team_select', function() {
                    const clickedElem = $(this),
                        tid = clickedElem.data('tid'),
                        team_name = clickedElem.data('tname'),
                        logo = clickedElem.data('logo')
                    ;

                    $('#av_team_id').val(tid);
                    $('#avatar_team').val(team_name);
                    $('#current_team_avatar').prop('src', logo).show();

                    // if team avatar is not selected, just update team logo without saving
                    if (!$('#av_team_id').is(':checked')) {
                        return;
                    }
                    // store new team
                    Ajax.profileSave({avatar_team_id: tid}, function(resp) {
                        applyAvatarUpdate(resp);
                    });
                });

            });
        }
    };
}();
